import { Conditions } from '../../rules/Conditions';

export function getMostImportantCondition(selectedConditions: string[]) {
  // Priority is given to Item_Name over Item_Sku
  if (selectedConditions.length > 1) {
    if (selectedConditions.includes(Conditions.Item_Name)) {
      return Conditions.Item_Name;
    } else if (selectedConditions.includes(Conditions.Item_Sku)) {
      return Conditions.Item_Sku;
    }
  }
  return selectedConditions[0];
}
